import React from 'react';
import ProfileBannerSC from './profile-banner.styled';
import { HeadingTwo } from '../typography';
import { FormattedMessage } from 'react-intl';
import dlt from '../../utils/default-lang';

const ProfileBanner = () => {
  return (
    <ProfileBannerSC>
      <div className="left-wrap">
        <HeadingTwo className="white left-wrap--main-headline">
          <FormattedMessage
            id="profile_banner_headline"
            defaultMessage={dlt['profile_banner_headline']}
          />
        </HeadingTwo>
      </div>
    </ProfileBannerSC>
  );
};

export default ProfileBanner;
